import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

import { LenguageItem } from '../../core/interface/i18n.interface';
import { LanguageService } from '../../core/service/i18n/language-service';




@Component({
  standalone: true,
  selector: 'app-lenguage-switcher',
  imports: [SelectModule, TooltipModule, FormsModule, CommonModule, TranslateModule],
  templateUrl: './lenguage-switcher.html',
  styleUrls: ['./lenguage-switcher.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LenguageSwitcher {
  @Input() ownstyle = '';
  @Input() btnlabel: string | null = null;
  lenguages: LenguageItem[] = [
    { label: 'Español', value: 'es', },
    { label: 'Inglés', value: 'en' },
    { label: 'Euskera', value: 'eu' },

  ]
  selectedLanguage: LenguageItem = { label: "Español", value: "es" };

  constructor(private languageService: LanguageService) { }


  ngOnInit(): void {
    this.languageService.language.subscribe(lang => {
      const selected = this.lenguages.find(item => item.value === lang);
      if (selected) {
        this.selectedLanguage = selected;
      }
    });
  }



  switchLanguage(event: any) {
    const selectedLang = event['value'];
    this.selectedLanguage = this.lenguages.find(item => item.value === selectedLang) || this.selectedLanguage;
    this.languageService.changeLanguage(this.selectedLanguage.value);
  }
}
